import React from 'react'
import { CandidatesListPage } from 'components/candidates'

type Props = {}

export const CandidatesList = (props: Props) => {
  return (
    <>
      <CandidatesListPage />
    </>
  )
}
